// Ring brings a keeper back from the Ring app to
// /app/connect/ring?nonce=<url-safe base64>&time=<epoch ms>. Read once and
// checked here; the server checks again and matches it only after sign-in.
export function readRingLinkParams(
  search = typeof window === 'undefined' ? '' : window.location.search
) {
  const q = new URLSearchParams(search || '');
  const nonce = q.get('nonce');
  const time = q.get('time');
  if (!nonce || !/^[A-Za-z0-9_-]{20,100}$/.test(nonce)) return null;
  if (!time || !/^\d{10,16}$/.test(time)) return null;
  return { nonce, time };
}
